import { HoverLoader } from "components";
import PageLayout from "layouts/PageLayout";
import { useState } from "react";

// @mui
export default function AnalyticsApp() {
  const [loading, setLoading] = useState(true);
  return (
    <PageLayout title="Analytics" isList={false} hideToolbar>
      {loading && <HoverLoader text="Processing..."/>}
      <iframe
        width="100%"
        style={{ height: '80vh', border: 0 }}
        src="https://lookerstudio.google.com/embed/reporting/4090be5b-7827-4dcd-b993-c857dc8e8e1e/page/kIV1C"
        allowFullScreen
        onLoad={() => setLoading(false)}
        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      >
      </iframe>
    </PageLayout>
  );
}
